import "./scanLimitInfo.css";

const ScanLimitInfo = () => {
  return (
    <div className="ScanLimitInfo">
      <h1>Error Redirecting</h1>
      <b>The QR Code Creator has reached their monthly allowance</b>
      <p>
        The QR Code will redirect to this page until they upgrade their plan or
        their allowance refreshes.
      </p>
    </div>
  );
};

export default ScanLimitInfo;
